'use client';

import { Input } from '@savvy-kit/components/input';
import { Label } from '@savvy-kit/components/label';
import { cn } from '@savvy-kit/lib/utils';

import type { TextFilterMeta, TextOperator } from '../../types/filter-meta';
import type { TextFilterValue } from '../../types/filter-values';
import { useOperatorOptions } from './hooks/use-operator-options';
import { FilterActions } from './shared/filter-actions';
import { FilterOperatorSelect } from './shared/filter-operator-select';

export type TextFilterProps = {
  readonly filterMeta?: TextFilterMeta;
  readonly value: TextFilterValue | undefined;
  readonly onChange: (value: TextFilterValue | undefined) => void;
  readonly className?: string;
};

export function TextFilter({ filterMeta, value, onChange, className }: TextFilterProps) {
  const operators = useOperatorOptions('text', filterMeta);
  const operator: TextOperator = value?.operator ?? 'contains';
  const textValue = value && value.operator !== 'isEmpty' ? value.value : '';

  return (
    <div className={cn('flex flex-col gap-3 p-3', className)}>
      <FilterOperatorSelect
        id="text-filter-operator"
        value={operator}
        options={operators}
        onChange={(op) => (op === 'isEmpty' ? onChange({ operator: 'isEmpty' }) : onChange(undefined))}
      />

      {operator !== 'isEmpty' && (
        <div className="flex flex-col gap-1.5">
          <Label htmlFor="text-filter-value">Value</Label>
          <Input
            id="text-filter-value"
            value={textValue}
            onChange={(e) => onChange(e.target.value ? { operator, value: e.target.value } : undefined)}
            placeholder="Enter text..."
          />
        </div>
      )}

      {value && <FilterActions onClear={() => onChange(undefined)} />}
    </div>
  );
}
